<template>
    <Button
        v-if="failedSyncs.length > 0"
        icon="pi pi-refresh"
        :severity="failedSyncs.length > 0 ? 'danger' : 'secondary'"
        label=""
        @click="toggleOp"
        aria-label="Sync Status"
    />
    <Popover ref="op">
        <div class="popover-container">
            <DataTable
                v-if="failedSyncs.length > 0"
                :value="failedSyncs"
                tableStyle="min-width: 50rem"
            >
                <Column field="fake" header="">
                    <template #body>
                        <Badge severity="danger" value="Not synced" />
                    </template>
                </Column>
                <Column field="identity.entityType" header="Type"></Column>
                <Column field="actions" header="Actions">
                    <template #body="slotProps">
                        <div class="sync-action-buttons">
                            <Button
                                severity="secondary"
                                label="View"
                                class="view-button"
                                aria-label="View"
                                as="RouterLink"
                                :to="{
                                    name: slotProps.data.page.name,
                                    params: slotProps.data.page.params,
                                }"
                            />
                            <Button
                                icon="pi pi-download"
                                severity="secondary"
                                label="Download"
                                @click="slotProps.data.actions.download()"
                                aria-label="Download"
                            />
                        </div>
                    </template>
                </Column>
                <Column field="details" header="Details">
                    <template #body="slotProps">
                        {{ slotProps.data.details || "..." }}
                    </template>
                </Column>
            </DataTable>
            <div class="info-text">
                <template v-if="failedSyncs.length > 1">
                    Manual actions are required.
                </template>
                <template v-else-if="failedSyncs.length > 0">
                    Manual action is required.
                </template>
                <template v-else-if="isBeingSynced">Syncing...</template>
                <template v-else-if="!isInSync">
                    There are changes that need to be synced.
                </template>
                <template v-else-if="isInSync">
                    Everything is up to date.
                </template>
            </div>
        </div>
    </Popover>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useSyncManager } from "@/stores/sync-store";
import Popover from "primevue/popover";

const op = ref<InstanceType<typeof Popover>>();
const toggleOp = (event: Event) => {
    op.value?.toggle(event);
};
const { failedSyncs, isBeingSynced, isInSync } = useSyncManager();
</script>

<style lang="scss" scoped>
.view-button {
    text-decoration: none;
}
</style>
